<template>
    <form @submit.prevent="submitForm" method="POST" class="mw-500 mx-auto my-ml">

        <template v-if="success_message.length">
            <h2 class="fw-bold text-center">
                Check your inbox!
            </h2>
            <p class="text-center my-md">{{ success_message }}</p>
            <template v-if="time > 0">
                <div class="d-flex align-center gap-md">
                    <div class="w-50 text-right">
                        <img :src="`${images_url}/login/mail.png`" class="d-inline-block" style="height:75px" loading="lazy" alt=""/>
                    </div>
                    <div class="w-50 ml-xs text-left">
                        <h1>
                            <strong>{{ time }}</strong> <span class="text-extra">sec</span>
                        </h1>
                    </div>
                </div>
                <div class="text-center mt-sm">until the next email can be sent</div>
            </template>
            <template v-else>
                <div class="text-center mt-ml">
                    <img :src="`${images_url}/login/mail.png`" class="d-inline-block" style="height:75px" loading="lazy" alt=""/>
                </div>
            </template>
        </template>

        <template v-else>
            <h2 class="fw-bold text-center">
                Claim your <span class="ticket-small">$500</span><br /> learning grant
            </h2>
            <div class="text-center mt-md mb-ml">
                Before we apply your grant, we need to get to know you. Enter your email to create or
                access your free account via a secure link.
            </div>

            <div class="mw-360 mx-auto">
                <div class="form-field">
                    <input
                        v-model="user.email"
                        name="email"
                        type="email"
                        id="email"
                        autocomplete="email"
                        placeholder=""
                        @blur="validateEmail"
                        :class="emailClasses"
                    />
                    <label for="email">Email<sup>*</sup></label>
                    <div class="alert--input" v-if="error_email.length">{{ error_email }}</div>
                </div>
                <div class="form-field">
                    <CustomSelect
                        v-model="user.code"
                        :options="codes"
                        placeholder="Select your country code"
                        label="Country code"
                        :require="true"
                        @update:modelValue="updateMask"
                    />
                </div>
                <div class="form-field">
                    <input
                        v-model="user.phone_number"
                        name="fn_num_2"
                        type="tel"
                        id="fn_num_2"
                        @input="handleInput"
                        @keydown="handleKeydown"
                        @blur="handleBlur"
                        :placeholder="activeMask"
                        required
                        :class="[emptyField( user.phone_number ), 'on_top']"
                    />
                    <label for="fn_num_2">Your phone number<sup>*</sup></label>
                </div>

                <button
                    :class="[
                    'w-100',
                    'btn',
                    'btn--primary',
                    'btn--large',
                    'btn--full',
                    'btn--loader',
                ]"
                    :disabled="isLoading"
                    @click="submitForm"
                >Continue</button>
                <div class="caption mt-sm text-dark-gray text-center">
                    <i class="icon-lock" /> By proceeding, you agree to our
                    <a :href="`https://${domain}/terms-and-conditions`" target="_blank">Terms of Service</a> and
                    <a :href="`https://${domain}/privacy-policy`" target="_blank">Privacy Policy</a>.
                </div>
            </div>
        </template>
    </form>
</template>

<script>
import { defineComponent } from 'vue'
import { toRaw } from 'vue';
import CustomSelect from "@/Goya/components/Common/CustomSelect.vue";
export default defineComponent({
    name: "login",
    components: {CustomSelect},
    data() {
        return {
            isLoading: false, // защита от множественных запросов
            images_url: '/templates/Goya/assets/images',

            time : 0, // таймер обратного отсчёта сколько секунд осталось до следующей отправки
            timerId: null,

            user: {
                email: '',
                phone_number: '',
                code: 'US',
                path: '/grant?n=true',
                w: true,
            },
            isEmailValid: false,
            codes: [],
            activeMask: '(###) ###-####',
            masks: {},
            error_email: '',
            error_message: '',
            success_message: '',
        }
    },
    computed: {
        domain() {
            return window.location.hostname.replace('www', '')
        },
        emailClasses() {
            return {
                'filled': this.isEmailValid && this.user.email,
                'error': !this.isEmailValid && this.user.email,
                'empty': ! this.isEmailValid && this.user.email.length === 0,
            };
        }
    },
    created() {
        this.loadCountries();
    },
    methods: {
        emptyField( field ) {
            const v = field.trim();
            return v !== '' ? 'filled' : 'empty';
        },

        isValidEmail() {
            const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            return regex.test( this.email ) || ! this.email;
        },

        /**
         * Отправка формы
         */
        async submitForm() {

            if( this.isLoading )
                return;

            if( ! this.isValidEmail( this.user.email ) ) {
                this.error_email = 'The email field is filled in incorrectly.';
                return;
            }

            this.isLoading = true
            this.error_email       = '';
            this.error_message     = '';
            this.success_message   = '';

            let obj = structuredClone( toRaw( this.user ) );
            obj.phone_number = this.getPhoneNumber();

            try {
                const response = await this.$http.post('/auth/loginEmail', obj)

                // Проверка структуры ответа
                if( ! response?.data ) {
                    this.error_message = 'Invalid response';
                    return;
                }

                const { status, data } = response?.data ?? {};
                if( status !== 'success' ) {
                    this.error_message = data?.message ?? 'Unknown error from server';
                    return;
                }

                this.success_message = data?.message ?? 'Please check your email to activate or/and log in to your account';

                // отправка события в Google Tag Manager
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'lead'
                });

                if( data?.time ) {
                    clearInterval(this.timerId); // Сброс старого таймера перед запуском

                    this.time = data.time
                    this.timerId = setInterval(() => {
                        if( --this.time <= 0) {
                            this.success_message = '';
                            clearInterval(this.timerId);
                        }
                    }, 1000);
                }
            } catch (err) {
                console.error('error: ', err)
                // показываем ошибку на странице
            } finally {
                this.isLoading = false
            }
        },

        validateEmail() {
            // Регулярка для валидации email (рекомендуемый вариант)
            const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

            if( ! this.user.email ) {
                this.isEmailValid = false;
                this.error_email = 'Email required';
            } else if ( ! regex.test( this.user.email ) ) {
                this.isEmailValid = false;
                this.error_email = 'Incorrect email';
            } else {
                this.isEmailValid = true;
                this.error_email = '';
            }
        },

        /**
         * Грузим страны и коды телефонов
         * @returns {Promise<void>}
         */
        async loadCountries() {
            this.loading = true;
            try {
                const response = await this.$http.post('/ref/countriesList')
                if( response.data.status === 'error' ) {
                    this.error = this.error.message
                    return;
                }

                const countries = response.data.data.countries

                let masks = {};
                let codes = [];

                Object.keys(countries).forEach((iso) => {
                    let country = countries[iso];
                    if( country?.mask && country?.cc && country?.name ) {

                        masks[ iso ] = country.mask.replace(country.cc, '')
                            .replace(/0/g, '#')
                            .trim();

                        codes.push({
                            value: iso,
                            label: `${country.name} ${country.cc}`,
                            code: country.cc,
                        });
                    }
                })

                // Сортируем: сначала страну по умолчанию, потом остальные по алфавиту
                codes.sort((a, b) => {
                    if (a.code === this.user.code) return -1;
                    if (b.code === this.user.code) return 1;
                    return a.label.localeCompare(b.label);
                });

                this.codes = codes;
                this.masks = masks;

            } catch (e) {
                console.error('error: ', e)
            } finally {
                this.loading = false;
            }
        },

        getPhoneNumber() {

            let c = this.masks[ this.user.code ];
            if( c ) {
                const phone = this.user.phone_number.replace(/\D/g, ""); // Только цифры
                if( phone.length ) {

                    c = c.replace(/\D/g, ""); // Только цифры

                    return `+${c}${phone}`;
                }
            }

            return '';
        },

        updateMask( value, isInitial = false ) {

            const mask = this.masks[ this.user.code ]
            if( ! mask || this.activeMask === mask ) return;

            this.activeMask = this.masks[ this.user.code ];

            if( ! isInitial ) {
                this.user.phone_number = '';
            }
        },

        handleKeydown(event) {
            if (event.key === 'Backspace') {
                const input = event.target;
                const start = input.selectionStart;
                const end = input.selectionEnd;

                // Если выделенного текста нет — обрабатываем умное удаление
                if (start === end && start > 0) {
                    const charToDelete = input.value[start - 1];

                    // Если перед курсором не цифра (дефис, скобка, пробел)
                    if (/\D/.test(charToDelete)) {
                        event.preventDefault(); // Останавливаем стандартный Backspace

                        // Ищем позицию последней цифры перед курсором
                        let lastDigitIndex = -1;
                        for (let i = start - 1; i >= 0; i--) {
                            if (/\d/.test(input.value[i])) {
                                lastDigitIndex = i;
                                break;
                            }
                        }

                        if (lastDigitIndex !== -1) {
                            // Удаляем эту цифру из v-model
                            const val = input.value;

                            // Обновляем значение и ставим курсор
                            this.user.phone_number = val.substring(0, lastDigitIndex) + val.substring(start);

                            this.$nextTick(() => {
                                // Ставим курсор туда, где была удалена цифра
                                input.setSelectionRange(lastDigitIndex, lastDigitIndex);
                                // Вызываем handleInput вручную, чтобы маска пересчиталась
                                this.handleInput({ target: input });
                            });
                        }
                    }
                }
            }
        },

        handleInput(event) {
            const input = event.target;
            const oldSelectionStart = input.selectionStart;
            const oldLength = input.value.length;

            const rawValue = input.value.replace(/\D/g, ""); // Только цифры

            if( rawValue.length === 0 ) {
                this.user.phone_number = ''
                return;
            }

            let formatted = "";
            let digitIndex = 0;

            // Проходим по маске и подставляем цифры
            for (let i = 0; i < this.activeMask.length; i++) {
                const maskChar = this.activeMask[i];

                if (maskChar === "#") {
                    // Если в маске решетка — берем следующую цифру из ввода
                    if (digitIndex < rawValue.length) {
                        formatted += rawValue[digitIndex];
                        digitIndex++;
                    } else {
                        break; // Цифры кончились
                    }
                } else {
                    formatted += maskChar;
                    if (digitIndex < rawValue.length && maskChar === rawValue[digitIndex]) {
                        digitIndex++;
                    }
                }
            }

            this.user.phone_number = formatted;

            // Возвращаем курсор на место, иначе он прыгнет в конец
            this.$nextTick(() => {
                // Вычисляем, насколько изменилась длина строки
                const lengthDiff = formatted.length - oldLength;
                let newPosition = oldSelectionStart + lengthDiff;

                // Магия: если курсор уперся в статичный символ маски (пробел, скобку),
                // двигаем его вперед до ближайшей "решетки" или конца строки
                while (
                    newPosition < formatted.length &&
                    this.activeMask[newPosition] !== "#" &&
                    formatted[newPosition] !== rawValue[rawValue.length - 1] // проверка на последнюю введенную цифру
                    ) {
                    newPosition++;
                }

                input.setSelectionRange(newPosition, newPosition);
            });
        },

        handleBlur() {
            const currentVal = this.user.phone_number;
            const currentDigits = currentVal.replace(/\D/g, "");
            const maskDigits = this.activeMask.replace(/[^0-9]/g, "");
            if (currentDigits === maskDigits || currentDigits.length === 0) {
                this.user.phone_number = ""; // Очищаем в ноль
            }
        }
    }
});
</script>

<style scoped>

</style>